"use client"
import React, { createContext, ReactNode, useState } from 'react';

import { Numerology } from '@/features/calculate/domain/interfaces';

export interface MainContextProps {
  takePdf: boolean;
  setTakePdf: React.Dispatch<React.SetStateAction<boolean>>;
  useInfo: Numerology | undefined;
  setUseInfo: React.Dispatch<React.SetStateAction<Numerology | undefined>>;
}

interface MainContextProviderProps {
  children: ReactNode;
}

export const MainContext = createContext<MainContextProps | undefined>(undefined);

export const MainContextProvider: React.FC<MainContextProviderProps> = ({ children }) => {
  const [takePdf, setTakePdf] = useState(true);
  const [useInfo, setUseInfo] = useState<Numerology>()

  return (
    <MainContext.Provider value={{ takePdf, setTakePdf, useInfo, setUseInfo }}>
      {children}
    </MainContext.Provider>
  );
};
